import React from 'react';
import PropTypes from "prop-types";
import {
  DatePicker as MUIDatePicker,
  TimePicker as MUITimePicker,
  DateTimePicker as MUIDateTimePicker
} from 'material-ui-pickers';
import InputLabel from 'material-ui/Input/InputLabel';
import tsl from '../../app/tsl';
import withValidations from './withValidations';
import FormHelperText from 'material-ui/Form/FormHelperText';
import FormControl from 'material-ui/Form/FormControl';
import { isNotEmpty } from './validations';

export const ValidatedDatePicker = withValidations(
  MUIDatePicker,
  isNotEmpty
);

export const ValidatedDateTimePicker = withValidations(
  MUIDateTimePicker,
  isNotEmpty
);

export const ValidatedTimePicker = withValidations(
  MUITimePicker,
  isNotEmpty
);




// WEBPACK FOOTER //
// ./components/forms/ValidatedPickers.js